module.exports = __webpack_public_path__ + "static/WEDDING E&M-89-4620d1983f40ea821d7d4255139ae9ee.jpg";